import React from 'react';

const Logo = ({ className = '', color = 'default', size = 'default', hideText = false }) => {
  const textColorClass = color === 'white' 
    ? 'text-white' 
    : 'bg-gradient-to-r from-gray-800 to-primary bg-clip-text text-transparent';
  const svgColorClass = color === 'white' ? 'invert brightness-0' : '';
  
  const sizeClasses = {
    default: { img: 'h-9', text: 'text-2xl', margin: 'ml-2.5' },
    large: { img: 'h-16', text: 'text-5xl', margin: 'ml-4' },
    xlarge: { img: 'h-24', text: 'text-7xl', margin: 'ml-6' }
  };
  
  const currentSize = sizeClasses[size] || sizeClasses.default;

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/pine.svg" 
        alt="Pine" 
        className={`${currentSize.img} ${svgColorClass}`}
        width="36"
        height="36"
        style={{ aspectRatio: '1/1' }}
      />
      {!hideText && (
        <span className={`${currentSize.text} font-bold ${currentSize.margin} ${textColorClass}`}>
          Randevu
        </span>
      )}
    </div>
  );
};

export default Logo;
